import { gql } from "@apollo/client";

export const GET_CONSUMER_BOOKINGS_ADVANCED = gql`
  query ConsumerBookingsAdvanced($args: ConsumerBookingsAdvancedInput!) {
    consumerBookingsAdvanced(args: $args) {
      bookings {
        id
        referenceNumber
        pickupDateTime
        dropoffDateTime
        status
        cancellationReason
        branch {
          id
          name
          timeZone
        }
        currentBookingSchedules {
          id
          vehicleStatus
          vehicle {
            id
            licencePlate
            isGhostVehicle
          }
        }
      }
      total
      page
      limit
      appliedFilters {
        searchTerm
        searchColumns
        statuses
        category
        sortBy
        sortOrder
      }
    }
  }
`;


